import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ProblemSection } from './components/ProblemSection';
import { MethodSection } from './components/MethodSection';
import { OfferStack } from './components/OfferStack';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ComparisonSection } from './components/ComparisonSection';
import { ForWhoSection } from './components/ForWhoSection';
import { UrgencySection } from './components/UrgencySection';
import { CheckoutSection } from './components/CheckoutSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  return <div className="min-h-screen bg-night-900 text-gray-100 font-sans selection:bg-accent-blue/30 selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <MethodSection data-id="element-4" />
      <OfferStack data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <ComparisonSection data-id="element-7" />
      <ForWhoSection data-id="element-8" />
      <UrgencySection data-id="element-9" />
      <CheckoutSection data-id="element-10" />
      <GuaranteeSection data-id="element-11" />
      <FAQSection data-id="element-12" />
      <FinalCTA data-id="element-13" />

      {/* Global Overlays */}
      <SocialProofPopup data-id="element-14" />
      <FloatingCTA data-id="element-15" />
    </div>;
}